document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('free-gift-modal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.free-gift-modal__close');
  const overlay = modal.querySelector('.free-gift-modal__overlay');
  function openModal() { modal.style.display = 'block'; }
  function closeModal() { modal.style.display = 'none'; }
  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  const giftIds = window.giftCollectionProductIds || [];

  // STEP 1 — detect gift-eligible add-to-cart, wait 2s, then show popup
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = args[0] instanceof Request ? args[0].url : args[0];
    const isAddToCart = typeof url === 'string' && url.includes('/cart/add');

    return originalFetch.apply(this, args).then(async (response) => {
      if (isAddToCart && response.ok) {
        try {
          const clone = response.clone();
          const data = await clone.json();
          const items = data.items || [data];
          if (items.some(item => giftIds.includes(item.product_id))) {
            setTimeout(openModal, 2000);
          }
        } catch (e) {}
      }
      return response;
    });
  };

  // STEP 2 — refresh the cart drawer HTML via Section Rendering API
  async function refreshCartDrawer() {
    const res = await originalFetch('/?sections=mini-cart');
    const data = await res.json();
    const newDrawerHTML = data['mini-cart'];

    // Parse and swap the <cart-drawer> element content
    const parser = new DOMParser();
    const doc = parser.parseFromString(newDrawerHTML, 'text/html');
    const newDrawer = doc.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }
  }

  // STEP 3 — open the drawer by clicking whatever already opens it in your header
  function openCartDrawer() {
    const trigger =
      document.querySelector('[aria-controls="mini-cart"]') ||
      document.querySelector('a[href="#mini-cart"]') ||
      document.querySelector('[data-cart-drawer-toggle]');

    if (trigger) {
      trigger.click();
    } else {
      console.warn('Cart drawer trigger not found — check the selector.');
    }
  }

  // "Add for Free" buttons inside the popup
  modal.querySelectorAll('.free-gift-add-btn').forEach(function (btn) {
    btn.addEventListener('click', async function () {
      const variantId = btn.dataset.variantId;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const res = await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (res.ok) {
          btn.textContent = 'Added ✓';
          await refreshCartDrawer();  // update drawer content live
          closeModal();               // close the gift popup
          openCartDrawer();           // open the cart drawer to show it
        } else {
          btn.disabled = false;
          btn.textContent = 'Add for Free';
        }
      } catch (err) {
        console.error('Failed to add gift', err);
        btn.disabled = false;
        btn.textContent = 'Add for Free';
      }
    });
  });
});